export default "__VITE_PUBLIC_ASSET__a464bf8a__"